import { Button, Col, Input, PageHeader, Row, Typography } from 'antd';
import React, { useEffect, useRef, useState } from 'react';

import { IngredientSimilarityResponseType } from './PageIngredientSimilarity';
import ordner from '../img/ordner.png';
import useFetch from '../hooks/fetcher';
import { useHistory } from 'react-router-dom';
const API_SERVICE_BASE_URL = process.env.REACT_APP_API_SERVICE_BASE_URL || '';

const { Text } = Typography;
type IngredientSearchResponseType = {
    error: boolean; // if data query successfully
    payload: string; // actual payload (may preprocessed by backend)
};

const gutterH = 16;
const gutterV = 16;
const colHelperProps = {
    xs: 0,
    sm: 0,
    md: 2,
    lg: 5,
    xl: 7,
};
const colContentProps = {
    xs: 24,
    sm: 24,
    md: 20,
    lg: 14,
    xl: 10,
};

type ErrorMessageType = {
    state: boolean;
};

const ErrorMessage: React.FC<ErrorMessageType> = (
    // eslint-disable-next-line react/prop-types
    { state }, // don't understand why toolchain don't understand this destructor
) => (
    <Row justify="space-between" gutter={[gutterH, gutterV]}>
        <Col {...colHelperProps}></Col>
        <Col {...colContentProps} style={{ display: 'flex' }}>
            <div style={{ color: 'red' }}>{state ? 'Search Failed' : ''}</div>
        </Col>
        <Col {...colHelperProps}></Col>
    </Row>
);

const PageIngredient: React.FC = () => {
    const [errorState, setErrorState] = useState(false); // keyword search result
    const [errorStateMol, setErrorStateMol] = useState(false); // mol structure search result
    const ChemDoodle = window.ChemDoodle;
    ChemDoodle.ELEMENT['H'].jmolColor = 'red';
    ChemDoodle.ELEMENT['S'].jmolColor = '#B9A130';
    const drawer = useRef<HTMLDivElement>(null);
    const sketcherRef = useRef(window.ChemDoodle.SketcherCanvas);
    const { get, create } = useFetch(API_SERVICE_BASE_URL);
    const history = useHistory();

    /** Paint chem structure on the canvas, (And scroll the screen to show canvas) */
    function load_pubchem(molstring: string) {
        const molstruct = ChemDoodle.readMOL(molstring); // TODO: try-catch access result
        sketcherRef.current.loadMolecule(molstruct);
        sketcherRef.current.repaint();
        if (drawer.current !== null) {
            drawer.current.scrollIntoView();
        }
    }

    function exportMol(format: string) {
        const mol = sketcherRef.current.getMolecule();
        const molFile = ChemDoodle.writeMOL(mol);
        setErrorStateMol(false);
        create('/api/ingredient_similarity.php', { type: 'input_mol', sim: molFile, searchtype: 'sim' }).then(
            (e: IngredientSimilarityResponseType) => {
                if (!e.ok) {
                    setErrorStateMol(true);
                    console.error('has some error when read current mol');
                    return;
                }
                history.push(`/ingredient/similarity`, { payload: e });
            },
        );
    }

    const insertExampleMol = () =>
        load_pubchem(
            '644241\n  -OEChem-09081506192D\n\n 61 65  0     0  0  0  0  0  0999 V2000\n    2.0000    1.3261    0.0000 F   0  0  0  0  0  0  0  0  0  0  0  0\n    3.3660    0.9600    0.0000 F   0  0  0  0  0  0  0  0  0  0  0  0\n    2.3660    2.6921    0.0000 F   0  0  0  0  0  0  0  0  0  0  0  0\n    5.4641    0.3261    0.0000 O   0  0  0  0  0  0  0  0  0  0  0  0\n    4.5981    4.8261    0.0000 N   0  0  0  0  0  0  0  0  0  0  0  0\n    6.3301    1.8261    0.0000 N   0  0  0  0  0  0  0  0  0  0  0  0\n    8.0622   -2.1739    0.0000 N   0  0  0  0  0  0  0  0  0  0  0  0\n    4.0981    6.3649    0.0000 N   0  0  0  0  0  0  0  0  0  0  0  0\n    7.1962   -3.6739    0.0000 N   0  0  0  0  0  0  0  0  0  0  0  0\n    6.3301   -2.1739    0.0000 N   0  0  0  0  0  0  0  0  0  0  0  0\n    7.1962   -6.6739    0.0000 N   0  0  0  0  0  0  0  0  0  0  0  0\n    4.5981    3.8261    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0\n    5.4641    2.3261    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0\n    3.7320   2.3261    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0\n    5.4641    3.3261    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0\n    3.7320    3.3261   0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0\n    4.5981    1.8261    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0\n    7.1962    0.3261    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0\n    8.0622   -1.1739    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0\n    8.9282   -0.6739    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0\n    7.1962   -0.6739    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0\n    6.3301    0.8261    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0\n    5.4071    5.4139    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0\n    8.0622    0.8261    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0\n    8.9282    0.3261    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0\n    2.8660    1.8261    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0\n    3.7891    5.4139   0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0\n    5.0981    6.3649    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0\n    9.7942   -1.1739    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0\n    7.1962   -2.6739    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0\n    5.6859    7.1739    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0\n    6.3301   -4.1739    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0\n    6.3301   -5.1739    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0\n    5.4641   -3.6739    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0\n    5.4641   -2.6739    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0\n    5.4641  -5.6739    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0\n    7.1962   -5.6739    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0\n    5.4641   -6.6739    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0\n    6.3301   -7.1739    0.0000 C   0  0  0  0  0  0  0  0  0  0  0  0\n    6.0010    3.6361    0.0000 H   0  0  0  0  0  0  0  0  0  0  0  0\n    3.1951    3.6361    0.0000 H   0  0  0  0  0  0  0  0  0  0  0  0\n    4.5981    1.2061    0.0000 H   0  0  0  0  0  0  0  0  0  0  0  0\n    6.8671    2.1361    0.0000 H   0  0  0  0  0  0  0  0  0  0  0  0\n    6.6592   -0.9839    0.0000 H   0  0  0  0  0  0  0  0  0  0  0  0\n    5.9967    5.2223    0.0000 H   0  0  0  0  0  0  0  0  0  0  0  0\n    8.0622    1.4461    0.0000 H   0  0  0  0  0  0  0  0  0  0  0  0\n    9.4651    0.6361    0.0000 H   0  0  0  0  0  0  0  0  0  0  0  0\n    3.1994    5.2223    0.0000 H   0  0  0  0  0  0  0  0  0  0  0  0\n    8.5991   -2.4839    0.0000 H   0  0  0  0  0  0  0  0  0  0  0  0\n    9.4842   -1.7109    0.0000 H   0  0  0  0  0  0  0  0  0  0  0  0\n    10.3312   -1.4839    0.0000 H   0  0  0  0  0  0  0  0  0  0  0  0\n    10.1042   -0.6370    0.0000 H   0  0  0  0  0  0  0  0  0  0  0  0\n    6.1874    6.8095    0.0000 H   0  0  0  0  0  0  0  0  0  0  0  0\n    6.0503    7.6755    0.0000 H   0  0  0  0  0  0  0  0  0  0  0  0\n    5.1843    7.5384    0.0000 H   0  0  0  0  0  0  0  0  0  0  0  0\n    4.9272   -3.9839    0.0000 H   0  0  0  0  0  0  0  0  0  0  0  0\n    4.9272   -2.3639    0.0000 H   0  0  0  0  0  0  0  0  0  0  0  0\n    4.9272   -5.3639    0.0000 H   0  0  0  0  0  0  0  0  0  0  0  0\n    7.7331   -5.3639    0.0000 H   0  0  0  0  0  0  0  0  0  0  0  0\n    4.9272   -6.9839    0.0000 H   0  0  0  0  0  0  0  0  0  0  0  0\n    6.3301   -7.7939    0.0000 H   0  0  0  0  0  0  0  0  0  0  0  0\n  1 26  1  0  0  0  0\n  2 26  1  0  0 0  0\n  3 26  1  0  0  0  0\n  4 22  2  0  0  0  0\n  5 12  1  0  0  0  0\n  5 23  1  0  0  0  0\n  5 27  1  0  0  0  0\n  6 13  1  0  0  0  0\n  6 22  1  0 0  0  0\n  6 43  1  0  0  0  0\n  7 19  1  0  0  0  0\n  7 30  1  0  0  0  0\n  7 49  1  0  0  0  0\n  8 27  2  0  0  0  0\n  8 28  1  0  0  0  0\n  9 30  1 0  0  0  0\n  9 32  2  0  0  0  0\n 10 30  2  0  0  0  0\n 10 35  1  0  0  0  0\n 11 37  1  0  0  0  0\n 11 39  2  0  0  0  0\n 12 15  1  0  0  0  0\n 12 16 2  0  0  0  0\n 13 15  2  0  0  0  0\n 13 17  1  0  0  0  0\n 14 16  1  0  0  0  0\n 14 17  2  0  0  0  0\n 14 26  1  0  0  0  0\n 15 40  1  0  0  0  0\n 16 41  1  0  0  0  0\n 17 42  1  0  0  0  0\n 18 21  2  0  0  0  0\n 18 22  1  0  0  0  0\n 18 24  1  0  0  0  0\n 19 20  2  0  0  0  0\n 19 21  1  0  0  0  0\n 20 25  1  0  0  0  0\n 20 29  1  0  0  0  0\n 21 44  1  0  0  0  0\n 23 28  2  0  0  0  0\n 23 45  1  0  0  0  0\n 24 25  2  0  0  0  0\n 24 46  1  0  0 0  0\n 25 47  1  0  0  0  0\n 27 48  1  0  0  0  0\n 28 31  1  0  0  0  0\n 29 50  1  0  0  0  0\n 29 51  1  0  0  0  0\n 29 52  1  0  0  0  0\n 31 53  1  0 0  0  0\n 31 54  1  0  0  0  0\n 31 55  1  0  0  0  0\n 32 33  1  0  0  0  0\n 32 34  1  0  0  0  0\n 33 36  1  0  0  0  0\n 33 37  2  0  0  0  0\n 34 35  2 0  0  0  0\n 34 56  1  0  0  0  0\n 35 57  1  0  0  0  0\n 36 38  2  0  0  0  0\n 36 58  1  0  0  0  0\n 37 59  1  0  0  0  0\n 38 39  1  0  0  0  0\n 38 60 1  0  0  0  0\n 39 61  1  0  0  0  0\nM  END',
        );

    const searchKeyword = (keyword: string, apiEndPoint: string) => {
        setErrorState(false);
        get(apiEndPoint, { name: keyword }).then((r: IngredientSearchResponseType) => {
            if (r.error) {
                console.error('has some error');
                setErrorState(true);
                return;
            }
            const usedPart = r.payload.split('END')[0] + 'END';
            load_pubchem(usedPart);
        });
    };

    useEffect(() => {
        const sketcher = new ChemDoodle.SketcherCanvas('sketcher_id', 800, 600, {
            useServices: true,
            oneMolecule: true,
        });
        sketcher.specs.atoms_displayTerminalCarbonLabels_2D = true;
        sketcher.specs.atoms_useJMOLColors = true;
        sketcher.specs.bonds_clearOverlaps_2D = true;
        sketcher.specs.atoms_implicitHydrogens_2D = true;
        sketcher.repaint();
        sketcherRef.current = sketcher;
    }, []);

    return (
        <div>
            <PageHeader title="Ingredient Search" style={{ marginBottom: '10vh' }} />
            <Row justify="space-between" gutter={[gutterH, gutterV]}>
                <Col {...colHelperProps}></Col>
                <Col {...colContentProps} style={{ display: 'flex' }}>
                    <Input.Search
                        style={{ flex: 1 }}
                        type="text"
                        size="large"
                        placeholder="Pubchem-Name search"
                        name="pubchem"
                        enterButton={<Button type="primary">Search</Button>}
                        onSearch={(e: string) => searchKeyword(e, '/api/search_pubchem_name.php')}
                    />
                </Col>
                <Col {...colHelperProps}>e.g. Nilotinib</Col>
            </Row>
            <Row justify="space-between" gutter={[gutterH, gutterV]}>
                <Col {...colHelperProps}></Col>
                <Col {...colContentProps} style={{ display: 'flex' }}>
                    <Input.Search
                        style={{ flex: 1 }}
                        type="text"
                        size="large"
                        placeholder="Smile search"
                        name="smiles"
                        enterButton={<Button type="primary">Search</Button>}
                        onSearch={(e: string) => searchKeyword(e, '/api/search_smile.php')}
                    />
                </Col>
                <Col {...colHelperProps}>e.g. CC1=C(C=C(C=C1)C(=O)</Col>
            </Row>
            <ErrorMessage state={errorState} />
            <Row justify="space-between" gutter={[gutterH, gutterV]}>
                <Col {...colHelperProps}></Col>
                <Col {...colContentProps} style={{ display: 'flex' }}>
                    By drawing a structure or searching by name or SMILES, a tanimoto comparison based on the ECFP4
                    fingerprint is performed. If your structure is not contained in our dataset the 10 most similar
                    ingredients will be shown. As an example molecule Nilotinib was chosen. It is a multi-kinase
                    inhibitor and measured by every consortium. By clicking on the insert example, Nilotinib is loaded
                    into ChemDoodle. To classify it, please click on Similarity search.
                </Col>
                <Col {...colHelperProps}></Col>
            </Row>
            <Row justify="space-between" gutter={[gutterH, gutterV]}>
                <Col {...colHelperProps}></Col>
                <Col {...colContentProps} style={{ display: 'flex' }}>
                    <ul>
                        <li>Search a molecule by its name via PubChem</li>
                        <li>Create a structure by a SMILES string</li>
                        <li>Draw your structure</li>
                        <li>
                            Load a molecule by clicking on <img src={ordner} width="25px" />
                        </li>
                    </ul>
                </Col>
                <Col {...colHelperProps}></Col>
            </Row>
            <Row justify="center" gutter={[gutterH, gutterV]}>
                <Col>
                    <canvas id="sketcher_id"></canvas>
                </Col>
            </Row>
            <ErrorMessage state={errorStateMol} />
            <Row justify="space-between" gutter={[gutterH, gutterV]}>
                <Col {...colHelperProps}></Col>
                <Col {...colContentProps}>
                    Please note that the calculation might take some seconds, because of standardization and similarity
                    comparison
                    <span style={{ color: 'red' }}> (10 to 20 seconds)</span>.
                </Col>
                <Col {...colHelperProps}></Col>
            </Row>
            <Row justify="center" gutter={[gutterH, gutterV]}>
                <Col>
                    <Button
                        name="searchtype"
                        type="primary"
                        size="large"
                        onClick={() => exportMol('smiles')}
                        value="simsearch"
                    >
                        Similarity Search
                    </Button>
                    &nbsp;
                    <Button type="default" size="large" onClick={insertExampleMol}>
                        Insert Example
                    </Button>
                </Col>
            </Row>
        </div>
    );
};

export default PageIngredient;
